<template>
    <div class="welcome-banner pb-2 text-700 fs-9">
        <template v-if="apiStore.currentAttendee">
            Welcome, {{ apiStore.currentAttendee.display_name }}
            <span v-if="apiStore.currentAttendee.registration_email_address">
                ({{ apiStore.currentAttendee.registration_email_address }})
            </span>
        </template>
        <template v-else>
            Welcome &mdash;
            <button type="button" class="welcome-banner-signin" @click="signIn">Sign in</button>
        </template>
    </div>
</template>

<script>
import {useApiStore} from '@/store/api'

export default {
    name: 'WelcomeBanner',

    setup() {
        const apiStore = useApiStore()
        return {apiStore}
    },

    methods: {
        async signIn() {
            const {signIn} = await import('@/auth/authRedirect')
            signIn()
        },
    },
}
</script>

<style scoped>
.welcome-banner {
    line-height: 1.4;
    word-break: break-word;
}

.welcome-banner .welcome-banner-signin {
    background: none;
    border: 0;
    padding: 0;
    color: inherit;
    font: inherit;
    text-decoration: underline;
    cursor: pointer;
    vertical-align: baseline;
}
</style>
